import type { LinkProps as MuiLinkProps } from '@mui/material/Link'
import { isString, startsWith } from 'lodash-es'
import { forwardRef } from 'react'
import type { NavLinkProps } from 'react-router-dom';
import { NavLink } from 'react-router-dom'

export type NavLinkBehaviorProps = Omit<NavLinkProps, 'to'> & {
  href: string
} & Omit<MuiLinkProps, 'href'>

/**
 * MUI Link に React Router DOM の機能を持たせるビヘイビア
 */
export const NavLinkBehavior = forwardRef<
  HTMLAnchorElement,
  NavLinkBehaviorProps
>(({ href, ...props }, ref) => {
  const isExternal =
    isString(href) && (startsWith(href, 'http') || startsWith(href, 'mailto:'))

  if (isExternal) {
    return /[/.]canaly\.net/.test(href) ? (
      <a ref={ref} href={href} {...props} />
    ) : (
      <a
        ref={ref}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        {...props}
      />
    );
  }

  return <NavLink ref={ref} to={href} end={href.endsWith('/')} {...props} />
})
